let keyCounter = 0;
/**
 * One key for one user action. Visible ASCII, 36 characters, UUID v4 shaped.
 *
 * The Hermes runtime of the mobile app has no `crypto` global, so `crypto.randomUUID()` throws there (found on the iOS simulator, CHT-756).
 * Without `crypto` the key is built from three parts that do not rely on each other: the time in milliseconds (48 bits), a counter that only
 * goes up in this process (12 bits), and 7 bytes of `Math.random()` (several draws). Two calls in the same millisecond differ by the counter;
 * two devices differ by the random bytes. A key is a de-duplication token for one action, not a secret.
 */
export function createIdempotencyKey() {
    const runtime = globalThis.crypto;
    if (typeof runtime?.randomUUID === "function")
        return runtime.randomUUID();
    const bytes = new Uint8Array(16);
    if (typeof runtime?.getRandomValues === "function") {
        runtime.getRandomValues(bytes);
    }
    else {
        const at = Date.now();
        // bytes 0 to 5: the time. Divide, never shift: a shift works on 32 bits.
        for (let index = 5, rest = at; index >= 0; index -= 1, rest = Math.floor(rest / 256)) {
            bytes[index] = rest % 256;
        }
        keyCounter = (keyCounter + 1) & 0x0fff;
        bytes[6] = (keyCounter >> 8) & 0x0f;
        bytes[7] = keyCounter & 0xff;
        for (let index = 8; index < 16; index += 1)
            bytes[index] = Math.floor(Math.random() * 256);
    }
    bytes[6] = ((bytes[6] ?? 0) & 0x0f) | 0x40;
    bytes[8] = ((bytes[8] ?? 0) & 0x3f) | 0x80;
    const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0")).join("");
    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
